<template>
  <v-menu bottom left v-if="menuList && menuList.length">
    <template v-slot:activator="{ on }">
      <v-btn color="blue" dark icon v-on="on">
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-tile
        class="cursor-pointer"
        v-for="menu in menuList"
        :key="menu.id"
        v-on:click="callMenuFunction(menu, item)"
      >
        <v-list-tile-title>{{ menu.name }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const chartNamespace = createNamespacedHelpers("charts");
export default {
  props: ["chart", "menuList", "user", "item", "mode"],
  data: function () {
    return {};
  },
  components: {},
  methods: {
    ...chartNamespace.mapMutations(["mSetSubChart"]),
    ...chartNamespace.mapActions(["aSetSubChart"]),
    callMenuFunction(params, item = null) {
      
      if(this.mode != 'view') {
        return;
      }
      if(!item) {
        item = {};
      }
      try {
        if(params.functionType == "openDashboard") {
          item.attr_popup = params.functionValue;
          // alert("callMenuFunction");
          this.aSetSubChart({chart: this.chart, item: item, settings: params})
        }
      } catch(error) {

      }
    }
  },
  computed: {},
  mounted: function () {},
  beforeDestroy() {},
};
</script>
